import { AvrlBidCalc } from "src/types/bid-rates";
import { HiViewGrid } from "react-icons/hi";
import { PiMathOperationsDuotone } from "react-icons/pi";
import { ScoreDisplay } from "src/components/value-display";
import { formatCurrency } from "src/types/number";
import { LaneData } from "src/types/rate-data";
import { Modal } from "src/components/modal";

export function BreakdownButton({
    laneData,
    // currentBidRates,
    calcDetails,
}: {
    laneData: LaneData | null;
    // currentBidRates: BidRates | null;
    calcDetails: AvrlBidCalc | null;
}) {
    const getModal = (id: string) => {
        return document.getElementById(id) as HTMLDialogElement;
    };
    const openModal = async (id: string) => {
        getModal(id).showModal();
    };
    const closeModal = async (id: string) => {
        getModal(id).close();
    };

    const usingAvrl = calcDetails?.HighBid == calcDetails?.AvrlRate;
    const isLocalMove = laneData?.originDat == laneData?.destinationDat;
    var logicTitle = isLocalMove
        ? "Local Move"
        : usingAvrl
          ? "Market Rate"
          : "Historical Rate";
    var logicText = isLocalMove
        ? "The calculated rates are preset for local moves."
        : usingAvrl
          ? "The calculated rates are based on current market rates."
          : "The calculated rates are based on recent historical rates.";

    return (
        <>
            <button
                className="btn btn-xs btn-outline flex justify-start"
                onClick={() => openModal("logicModal")}
            >
                <span className="flex gap-2 items-start">
                    <HiViewGrid className="w-4 h-4" />
                    See Breakdown
                </span>
            </button>

            <Modal id="logicModal" style="max-w-4xl">
                <div className="flex flex-col items-center justify-center gap-4">
                    <div className="flex gap-4">
                        <div className="bg-gray-100 p-5 rounded-full">
                            <PiMathOperationsDuotone className="w-16 h-16 text-[#ac2226]" />
                        </div>
                        <div className="flex flex-col justify-center max-w-md">
                            <h2 className="text-xl font-bold text-gray-700 mb-2">
                                {logicTitle}
                            </h2>
                            <p className="text-gray-600">
                                {logicText}
                                <br />v{calcDetails?.Version}
                            </p>
                        </div>
                    </div>

                    <div className="grid grid-cols-2 grid-rows-2 gap-4 w-full">
                        <ScoreDisplay
                            title="Current Market Rate"
                            value={formatCurrency(calcDetails?.AvrlRate)}
                            text={"All in rate plus margin."}
                            pass={usingAvrl && !isLocalMove}
                        />

                        <ScoreDisplay
                            title="Recent Contract High"
                            value={formatCurrency(
                                calcDetails?.ContractOverrideRate,
                            )}
                            text={
                                "Highest contracted customer rate in prev 60 days, excluding outliers."
                            }
                            pass={!usingAvrl && !isLocalMove}
                        />

                        <ScoreDisplay
                            title="Minimums"
                            value={calcDetails?.HighBid == 800 ? "Yes" : "No"}
                            text={
                                "Used if market rates are below acceptable thresholds."
                            }
                            pass={calcDetails?.HighBid == 800}
                        />

                        <ScoreDisplay
                            title="Local Moves"
                            value={isLocalMove ? "Yes" : "No"}
                            text={"Pricing designed for local moves."}
                            pass={isLocalMove}
                        />
                    </div>

                    <button
                        type="reset"
                        className="btn btn-link mt-2"
                        onClick={() => closeModal("logicModal")}
                    >
                        Close
                    </button>
                </div>
            </Modal>
        </>
    );
}
